const overviewRouterPaths = {
  root: '/overview',
};

export default overviewRouterPaths;
